import { Component, Input } from '@angular/core';

import { OpsOrderModel } from '../../../../models/order.ops';

@Component({
  selector: 'order-items-card',
  templateUrl: 'order-items-card.html',
})
export class OrderItemsCardComponent {
  @Input('order') order: OpsOrderModel;

  get show() {
    return (
      this.order.orderItems.length > 1 ||
      this.order.orderItems.some(item => item.description != item.serviceName)
    );
  }

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/pages/order-detail/components/order-items-card/order-items-card.ts